<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="1100px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <ChooseFabric
      ref="ChooseFabricInner"
      :type="type"
      :height="height"
      :scmCode="scmCode"
      :fabricExpenseCode="fabricExpenseCode"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import ChooseFabric from './index.vue'
export default {
  components: { ChooseFabric },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    type: { type: String, default: 'radio' },
    height: { type: Number, default: 360 },
    scmCode: { type: String, default: '' },
    fabricExpenseCode: { type: String, default: '' },
  },
  methods: {
    confirm() {
      const data = this.$refs.ChooseFabricInner.choiceData()
      if (!data) return

      this.$emit('confirm', data)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
